import { configureStore } from '@reduxjs/toolkit'
import { tenderApi } from 'services/tender'
import { tenderCommissionMembersApi } from 'services/tender/tenderCommissionMember'
import { tenderCommissionsApi } from 'services/tender/tenderCommissions'
import { tenderContactPeopleApi } from 'services/tender/tenderContactPersons'
import { tenderInstructionsApi } from 'services/tender/tenderInstructions'
import { tenderRequirementsApi } from 'services/tender/tenderRequirements'
import { tenderRequirementItemsApi } from 'services/tender/tenderRequirementItem'
import { bidDescriptionsApi } from 'services/bids/bidDescriptions'
import { bidProcurementItemsApi } from 'services/bids/bidProcurementItems'
import { bidTechnicalFactorItemsApi } from 'services/bids/bidTechnicalFactorItems'
import { procurementPlansApi } from 'services/procurementPlans'
import { procurementPlanItemsApi } from 'services/procurementPlans/procurementPlanItems'
import { procurementPlanLogsApi } from 'services/procurementPlans/procurementPlanLogs'
import { usersApi } from 'services/users'
import { invitationsApi } from 'services/invitations'
import { lotsApi } from 'services/lots'
import { organizationsApi } from 'services/organizations'
import { systemSettingsApi } from 'services/systemSettings'
import { fileApi } from 'services/file'
import { rtkQueryErrorLogger } from './errorMiddleware'
import { bankAccountsApi } from 'services/bankAccounts'
import { lotData } from './slice/lot'
import { technicalRequirementItemsApi } from 'services/lot/technical-requirements'
import { procurementRequirementItemsApi } from 'services/lot/procurement-requirements'
import { videoInstructionsApi } from 'services/video-instructions'
import { notificationApi } from 'services/notification'
import { announcementsApi } from 'services/announcements'
import { threadTopicsApi, threadMessagesApi } from 'services/thread'
import { submissionApi, documentSubmissionApi } from 'services/submissions'
import { termsConditionsApi } from 'services/terms-conditions'
import { technicalSubmissionApi } from 'services/submissions/technical-submissions'
import { procurementSubmissionApi } from 'services/submissions/procurement-submission'
import { infoCenterFaqApi } from 'services/info-center/faq'
import { infoCenterNewsApi } from 'services/info-center/news'
import { infoCenterReportsApi } from 'services/info-center/reports'
import { procurementRequirementApi } from 'services/lot/procurement-requirements'
import { tenderEvaluationApi } from 'services/tender/tenderEvaluation'
import { submissionEvaluationApi } from 'services/submissions/submission-evaluation'
import { commissionEvaluationApi } from 'services/commission-evaluation/commission-evaluation'
import { paymentsApi } from 'services/payment'
import { procurementsApi } from 'services/procurements'
import { nonResidentApi } from 'services/auth/nonResident'
import { logoutApi } from 'services/auth/logout'
import { tenderFinalProtocolApi } from 'services/final-protocol'
import { contractsApi } from 'services/contracts';
import { committeeEvaluationApi } from 'services/committee-evaluation';


export const store = configureStore({
  reducer: {
    [lotData.name]: lotData.reducer,
    [tenderApi.reducerPath]: tenderApi.reducer,
    [tenderCommissionMembersApi.reducerPath]: tenderCommissionMembersApi.reducer,
    [tenderCommissionsApi.reducerPath]: tenderCommissionsApi.reducer,
    [tenderContactPeopleApi.reducerPath]: tenderContactPeopleApi.reducer,
    [tenderInstructionsApi.reducerPath]: tenderInstructionsApi.reducer,
    [tenderRequirementsApi.reducerPath]: tenderRequirementsApi.reducer,
    [tenderRequirementItemsApi.reducerPath]: tenderRequirementItemsApi.reducer,
    [technicalRequirementItemsApi.reducerPath]: technicalRequirementItemsApi.reducer,
    [procurementRequirementItemsApi.reducerPath]:
      procurementRequirementItemsApi.reducer,
    [bidDescriptionsApi.reducerPath]: bidDescriptionsApi.reducer,
    [bidProcurementItemsApi.reducerPath]: bidProcurementItemsApi.reducer,
    [bidTechnicalFactorItemsApi.reducerPath]: bidTechnicalFactorItemsApi.reducer,
    [procurementPlansApi.reducerPath]: procurementPlansApi.reducer,
    [procurementPlanItemsApi.reducerPath]: procurementPlanItemsApi.reducer,
    [procurementPlanLogsApi.reducerPath]: procurementPlanLogsApi.reducer,
    [invitationsApi.reducerPath]: invitationsApi.reducer,
    [lotsApi.reducerPath]: lotsApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [systemSettingsApi.reducerPath]: systemSettingsApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [bankAccountsApi.reducerPath]: bankAccountsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [videoInstructionsApi.reducerPath]: videoInstructionsApi.reducer,
    [threadTopicsApi.reducerPath]: threadTopicsApi.reducer,
    [threadMessagesApi.reducerPath]: threadMessagesApi.reducer,
    [announcementsApi.reducerPath]: announcementsApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [documentSubmissionApi.reducerPath]: documentSubmissionApi.reducer,
    [technicalSubmissionApi.reducerPath]: technicalSubmissionApi.reducer,
    [procurementSubmissionApi.reducerPath]: procurementSubmissionApi.reducer,
    [submissionApi.reducerPath]: submissionApi.reducer,
    [termsConditionsApi.reducerPath]: termsConditionsApi.reducer,
    [infoCenterFaqApi.reducerPath]: infoCenterFaqApi.reducer,
    [infoCenterNewsApi.reducerPath]: infoCenterNewsApi.reducer,
    [infoCenterReportsApi.reducerPath]: infoCenterReportsApi.reducer,
    [procurementRequirementApi.reducerPath]: procurementRequirementApi.reducer,
    [tenderEvaluationApi.reducerPath]: tenderEvaluationApi.reducer,
    [submissionEvaluationApi.reducerPath]: submissionEvaluationApi.reducer,
    [commissionEvaluationApi.reducerPath]: commissionEvaluationApi.reducer,
    [committeeEvaluationApi.reducerPath]: committeeEvaluationApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [procurementsApi.reducerPath]: procurementsApi.reducer,
    [nonResidentApi.reducerPath]: nonResidentApi.reducer,
    [logoutApi.reducerPath]: logoutApi.reducer,
    [tenderFinalProtocolApi.reducerPath]: tenderFinalProtocolApi.reducer,
    [contractsApi.reducerPath]: contractsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      tenderApi.middleware,
      tenderCommissionMembersApi.middleware,
      tenderCommissionsApi.middleware,
      tenderContactPeopleApi.middleware,
      tenderInstructionsApi.middleware,
      tenderRequirementsApi.middleware,
      tenderRequirementItemsApi.middleware,
      technicalRequirementItemsApi.middleware,
      procurementRequirementItemsApi.middleware,
      bidDescriptionsApi.middleware,
      bidProcurementItemsApi.middleware,
      bidTechnicalFactorItemsApi.middleware,
      procurementPlansApi.middleware,
      procurementPlanItemsApi.middleware,
      procurementPlanLogsApi.middleware,
      invitationsApi.middleware,
      lotsApi.middleware,
      organizationsApi.middleware,
      systemSettingsApi.middleware,
      fileApi.middleware,
      bankAccountsApi.middleware,
      usersApi.middleware,
      videoInstructionsApi.middleware,
      threadTopicsApi.middleware,
      threadMessagesApi.middleware,
      announcementsApi.middleware,
      notificationApi.middleware,
      documentSubmissionApi.middleware,
      technicalSubmissionApi.middleware,
      procurementSubmissionApi.middleware,
      submissionApi.middleware,
      termsConditionsApi.middleware,
      infoCenterFaqApi.middleware,
      infoCenterNewsApi.middleware,
      infoCenterReportsApi.middleware,
      procurementRequirementApi.middleware,
      tenderEvaluationApi.middleware,
      submissionEvaluationApi.middleware,
      commissionEvaluationApi.middleware,
      paymentsApi.middleware,
      procurementsApi.middleware,
      nonResidentApi.middleware,
      logoutApi.middleware,
      tenderFinalProtocolApi.middleware,
      contractsApi.middleware,
      committeeEvaluationApi.middleware,
      rtkQueryErrorLogger,
    ]),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
